import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Form,
  Row,
  Col,
} from "reactstrap";
import { LibroService } from "service/LibroService";
import FSelect from "components/Select/FSelect";

const libroService = new LibroService();

const ModalLibro = ({ isOpen, toggle, selectedLibro, tipoDefault, onSave }) => {
  const [libro, setLibro] = useState({
    tomo: "",
    titulo: "",
    url: "",
    tipo: tipoDefault || "Material",
    estado: "Activo",
  });

  useEffect(() => {
    if (isOpen) {
      if (selectedLibro) {
        setLibro(selectedLibro);
      } else {
        setLibro({
          tomo: "",
          titulo: "",
          url: "",
          tipo: tipoDefault || "Material",
          estado: "Activo",
        });
      }
    }
  }, [isOpen, selectedLibro, tipoDefault]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLibro((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!libro.titulo.trim()) {
      alert("El título es obligatorio");
      return;
    }
    try {
      let res;
      if (libro._id) {
        res = await libroService.updateLibro(libro);
      } else {
        res = await libroService.addLibro(libro);
      }
      if (res?.confirmation === "success") {
        alert(libro._id ? "Registro actualizado" : "Registro guardado");
        onSave();
        toggle();
      } else {
        alert(res?.message || "Error al procesar la solicitud");
      }
    } catch (error) {
      console.error("Error guardando libro:", error);
    }
  };

  const esHorario = libro.tipo === "Horario";

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md" backdrop="static">
      <ModalHeader toggle={toggle}>
        {libro._id
          ? `Editar ${esHorario ? "Horario" : "Material"}`
          : `Agregar ${esHorario ? "Horario" : "Material"}`}
      </ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            {!esHorario && (
              <Col md="4">
                <FormGroup>
                  <Label>Tomo</Label>
                  <Input
                    type="number"
                    name="tomo"
                    value={libro.tomo}
                    onChange={handleChange}
                    placeholder="Nro."
                  />
                </FormGroup>
              </Col>
            )}
            <Col md={esHorario ? "12" : "8"}>
              <FormGroup>
                <Label>{esHorario ? "Descripción" : "Título"}</Label>
                <Input
                  name="titulo"
                  value={libro.titulo}
                  onChange={handleChange}
                  placeholder={esHorario ? "Descripción del horario" : "Título del material"}
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label>URL / Enlace</Label>
            <Input
              name="url"
              value={libro.url}
              onChange={handleChange}
              placeholder="https://..."
            />
          </FormGroup>
          <FormGroup>
            <Label>Estado</Label>
            <FSelect
              name="estado"
              value={libro.estado}
              onChange={handleChange}
              options={[
                { value: "Activo", label: "Activo" },
                { value: "Inactivo", label: "Inactivo" },
              ]}
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
        <Button color={esHorario ? "warning" : "primary"} onClick={handleSave}>
          Guardar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalLibro;
